import React from 'react';
import { useDispatch } from 'react-redux';
import OrderRowProductCard from '../OrderRowProductCard/OrderRowProductCard';
import CheckoutSection from './utils/Checkout.Section';
import { translate } from '../../Services/translation';
import CheckoutOrderSummary from './Checkout.OrderSummary';
import { update } from '../../Actions/Cart.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { OrderRow } from '../../Types/OrderRow';

const Cart = () => {
  const dispatch = useDispatch();
  const cart = useTypedSelector((state) => state.cart);
  const hasOrderRows =
    cart.orderRows && Object.keys(cart.orderRows).length > 0;
  const removeRow = (row: OrderRow) => {
    dispatch(update(row.articleNumber, 0, row.rowSystemId));
  };
  const { currentType } = useTypedSelector((state) => state.priceToggle);

  return (
    <CheckoutSection className="flex flex-col gap-6">
      <h4 className="uppercase">
        {translate('checkout.cart.title') +
          ' (' +
          cart.orderRows.length +
          ')'}
      </h4>
      {hasOrderRows && (
        <div className="flex flex-col gap-2">
          {Object.values(cart.orderRows).map((row: any) => (
            <OrderRowProductCard
              key={row.rowSystemId}
              row={row}
              onRemoveClick={() => removeRow(row)}
              priceToggleType={currentType}
            />
          ))}
        </div>
      )}
      <CheckoutOrderSummary className="lg:hidden" />
    </CheckoutSection>
  );
};

export default Cart;
